import {
  Text,
  Box,
  useToast,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Spinner
} from '@chakra-ui/react';
import Image from 'next/legacy/image';
import {
  IconAlertCircle,
} from '../../../../../styles/icons';
import {
  profileAccordionButton,
  profileAccordionPanel,
} from '../../../../utilities/render-helpers/renderPractitionerProfile';
import { useSelector, useDispatch } from 'react-redux';
import {AvatarUploader} from '../common-forms/AvatarUploader'
import { useState } from 'react';
import {patchData, postData} from '../../../../utilities/axios';
import { updateUserDetails } from '../../../../redux/actions/user';
import * as N from '../../../../utilities/notifications';
import axios from 'axios';
import isEmpty from 'lodash.isempty';
import {Button} from '@headlessui/react';

const EditSectionProfileImage = ({ profile }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.user.JWTToken);
  const {profileImage,} = profile;

  const [avatarImage, setAvatarImage] = useState(null);
  const [newImage, setNewImage] = useState(null);
  const [imageSubmitting, setImageSubmitting] = useState(false);
  const toast = useToast();

  const saveNewAvatarImage = async () => {
    setImageSubmitting(true);

    try {
      if (avatarImage === profileImage) {
        return;
      }

      const response = await postData(
        token,
        {
          type: 'avatar',
          contentType: 'image/webp',
        },
        `${process.env.NEXT_PUBLIC_NEW_USER_URL}profile/media`,
        process.env.NEXT_PUBLIC_NEW_USER_APIKEY
      );

      const base64Data = Buffer.from(
        avatarImage.replace(/^data:image\/\w+;base64,/, ''),
        'base64'
      );

      await axios.put(response.s3PutDetails.url, base64Data, {
        headers: {
          ...response.s3PutDetails.headers,
          'Access-Control-Allow-Origin': '*',
          'Content-Encoding': 'base64',
        }
      })

      setNewImage(response.publicUrl);

      let userUpdateProfile = {
        profileId: profile.profileId,
        practitionerType: 'therapist',
        profileImage: response.publicUrl,
      };

      await patchData(
        token,
        userUpdateProfile,
        `${process.env.NEXT_PUBLIC_NEW_USER_URL}profile`
      );

      dispatch(
        updateUserDetails({
          therapistProfile: {
            ...profile,
            ...userUpdateProfile,
          },
        })
      )

      toast(N.updateDetailsSuccess);
      setImageSubmitting(false);
    } catch (error) {
      console.error('PROBLEM SAVING NEW AVATAR', error);
      toast(N.updateDetailsFail(error));
      setImageSubmitting(false);
    }
  };

  return (
    <AccordionItem>
      <h2>
        <AccordionButton _expanded={profileAccordionButton}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flex="1"
            //width="100%"
            textAlign="left"
          >
            <Box display="flex" alignItems="center">
              <Text>Profile photo</Text>
              <Box
                width="40px"
                height="40px"
                borderRadius="50%"
                overflow="hidden"
                position="relative"
                margin="16px"
              >
                <Image
                  layout="fill"
                  alt="practitioner photo"
                  objectFit="cover"
                  objectPosition="center"
                  src={
                    newImage || (profileImage !== null && !isEmpty(profileImage)
                      ? profileImage
                      : '/images/profileHeader.jpg')
                  }
                  unoptimized
                  placeholder="blur"
                  blurDataURL="data:image/jpeg;base64,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"
                />
              </Box>
            </Box>
            {profileImage !== null && !isEmpty(profileImage) ? (
              <Text padding="8px" textStyle="body2" color="green">
                Complete
              </Text>
            ) : (
              <Box display="flex" alignItems="center" padding="8px">
                <IconAlertCircle size="20px" color="tomato" />
                <Text textStyle="body2" paddingLeft="8px">
                  Please add a photo to your profile
                </Text>
              </Box>
            )}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel sx={profileAccordionPanel}>
        <div className="flex flex-col rounded items-start gap-6 w-full bg-white p-4">
          <div className="w-full">
            <AvatarUploader
              initialImage={avatarImage}
              editorWidth={240}
              editorHeight={240}
              editorRadius={120}
              handleImageChange={setAvatarImage}
            />
            {avatarImage && (
              <div className='flex items-center justify-center w-full p-2'>
                <Button
                  disabled={imageSubmitting}
                  onClick={imageSubmitting ? () => {} : saveNewAvatarImage}
                  className='rounded-full flex items-center bg-[#587500] text-white opacity-1 transition px-4 py-2  hover:opacity-[0.7] cursor-pointer data-[disabled]:cursor-not-allowed data-[disabled]:opacity-[0.7]'>
                  {imageSubmitting ? <><Spinner color='white' size='sm' className='mr-3' /> Saving...</> :'Save and upload'}
                </Button>
              </div>
            )}
          </div>
        </div>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default EditSectionProfileImage;
